import isPropValid from '@emotion/is-prop-valid';
import { styled } from '@ori-ui/mui';

import { maxWidth } from '../constants/style';

export const HighlightGrid = styled('div', {
  shouldForwardProp: (propName: string) => isPropValid(propName),
})<{ isMobileOffice?: boolean | undefined }>(({ isMobileOffice, theme }) => ({
  maxWidth,
  margin: '0 auto',
  display: 'grid',
  gridTemplateColumns: '3fr 1fr',
  columnGap: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr',
  },
  ...(isMobileOffice && {
    '@media (min-width: 1025px)': {
      margin: theme.spacing(0, 6),
      borderLeft: '280px solid transparent',
    },
    '@media (min-width: 1604px)': {
      margin: '0 auto',
      borderLeft: 'none',
    },
  }),
}));
